// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"667":"3dd1f6bf","810":"fda34c60","1901":"e7d17f77","3065":"99a6a7b8","4677":"fda34c60","5380":"fda34c60","8529":"2b25b136"}[chunkId] + ".chunk.css";
};